import { useTheme } from '@emotion/react'

import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import GettingStarted from '@segment/templates/GettingStarted'

import LayoutBase from '@segment/next-shared/layout'

import Hero from './components/Hero'
import LogoCarousel from './components/LogoCarousel'
import Testimonials from './components/Testimonials'
import UseSegment from './components/UseSegment'
import CentralizeAndSimplify from './components/CentralizeAndSimplify'
import PersonalizeEveryInteraction from './components/PersonalizeEveryInteraction'
import MakeInformedDecisions from './components/MakeInformedDecisions'
import PropCardCta from './components/PropCardCta'
import SecurityHighlight from './components/SecurityHighlight'

import OgImagePng from './assets/OgSegmentIndustryFinancialServices.png'

const IndustryFinancialServicesView = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <LayoutBase
        pageTitle="Industry: Financial Services | Twilio Segment"
        pageDescription="Twilio Segment for Financial Services"
        pageOG={OgImagePng}
        themeColor={theme.palette.neutrals.white[100]}
      >
        <Navigation />
        <main>
          <Hero />
          <LogoCarousel />
          <MainContent>
            <CentralizeAndSimplify />
            <MakeInformedDecisions />
            <PersonalizeEveryInteraction />
            <PropCardCta />
            <SecurityHighlight />
            <UseSegment />
            <Testimonials />
          </MainContent>
          <GettingStarted />
        </main>
        <Footer />
      </LayoutBase>
    </AppearanceProvider>
  )
}

const MainContent = styled.div`
  background: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default IndustryFinancialServicesView
